<script setup lang="ts">

// Props
const props = defineProps({
  showLoginModal: Boolean,
  showRegisterModal: Boolean,
  hotelId: Number
})

// Emits
const emit = defineEmits(['update:showLoginModal', 'update:showRegisterModal', 'login-success', 'register-success'])

// Estados locales para los modales
const localShowLoginModal = computed({
  get: () => props.showLoginModal,
  set: (value) => emit('update:showLoginModal', value)
})

const localShowRegisterModal = computed({
  get: () => props.showRegisterModal,
  set: (value) => emit('update:showRegisterModal', value)
})

// Funciones para manejar eventos
const handleLoginSuccess = (data: unknown) => {
  emit('login-success', data)
  localShowLoginModal.value = false
}

const handleRegisterSuccess = (data: unknown) => {
  emit('register-success', data)
  localShowRegisterModal.value = false
}

const showRegisterFromLogin = () => {
  localShowLoginModal.value = false
  localShowRegisterModal.value = true
}

const showLoginFromRegister = () => {
  localShowRegisterModal.value = false
  localShowLoginModal.value = true
}
</script>

<template>
  <!-- Modal de login -->
  <UModal 
    v-model:open="localShowLoginModal" 
    :ui="{ content: 'sm:max-w-xl py-8 overflow-y-auto' }"
  >
    <template #content>
      <div class="absolute top-2 right-3 w-10 h-10 z-10 flex justify-end border-0">
        <UButton
          icon="i-lucide-x"
          color="neutral"
          variant="link"
          size="md"
          @click="() => { localShowLoginModal = false }"
        />
      </div>
      <div class="flex flex-col gap-8 w-full max-w-md mx-auto p-4">
        <h1 class="text-2xl sm:text-4xl text-center">{{ $t('labels.login.title') }}</h1>
        <LoginForm
          :show-register-link="true"
          :show-separator="true"
          :show-social-buttons="true"
          :link-register="false"
          :hotel-id="hotelId"
          @login-success="handleLoginSuccess"
          @show-register="showRegisterFromLogin"
        />
      </div>
    </template>
  </UModal>

  <!-- Modal de registro -->
  <UModal 
    v-model:open="localShowRegisterModal" 
    :ui="{ content: 'sm:max-w-xl py-8 overflow-y-auto' }"
  >
    <template #content>
      <div class="absolute top-2 right-3 w-10 h-10 z-10 flex justify-end border-0">
        <UButton
          icon="i-lucide-x"
          color="neutral"
          variant="link"
          size="md"
          @click="() => { localShowRegisterModal = false }"
        />
      </div>
      <div class="flex flex-col gap-8 w-full max-w-md mx-auto p-4">
        <h1 class="text-2xl sm:text-4xl text-center">{{ $t('labels.login.register.title') }}</h1>
        <RegisterForm
          :show-login-link="true"
          :show-separator="true"
          :show-social-buttons="true"
          :link-login="false"
          :hotel-id="hotelId"
          @register-success="handleRegisterSuccess"
          @show-login="showLoginFromRegister"
        />
      </div>
    </template>
  </UModal>
</template> 